export const HISTORY_INCREMENT_TRANSACTION = '[HISTORY] INCREMENT TRANSACTION';
export const HISTORY_INCREMENT_ACTIVITY = '[HISTORY] INCREMENT ACTIVITY';

export function history_increment_transaction() {
  return {
    type: HISTORY_INCREMENT_TRANSACTION,
  };
}

export function history_increment_activity() {
  return {
    type: HISTORY_INCREMENT_ACTIVITY,
  };
}
